import { NEW_EDITOR_DEFAULT_TEXT, NEW_EDITOR_DEFAULT_VOICE } from '../../lib/constants';

export type Style = 'Podcast' | 'Youtube' | 'Training'| 'Story Telling' | 'Sports Commentator' | 'Professional Intro';

export interface StyleDetail {
  style: Style;
  prompt?: string;
  default?: boolean;
  defaultText?: string;
  defaultVoice?: string;
}

export const sentences: StyleDetail[] = [
  {
    style: 'Podcast',
  },
  { style: 'Youtube' },
  { style: 'Training' },
  
];

export const newStyles: StyleDetail[] = [
  {
    style: 'Story Telling',
    prompt:
      'A calm, enchanting voice with a touch of mystique — smooth and measured, with subtle rises that draw the listener deeper into the world of Vyrneth. The tone should feel ancient yet ageless, like someone who\'s seen centuries unfold but still speaks with warmth and curiosity.',
    default: true,
    defaultText: NEW_EDITOR_DEFAULT_TEXT,
    defaultVoice: NEW_EDITOR_DEFAULT_VOICE,
  },
  {
    style: 'Training',
    prompt:
      'A clear, upbeat voice with a friendly tone and a touch of enthusiasm. Mid-range pitch — not too deep or too high — conveying confidence and trust. Smooth pacing, with subtle emphasis on key phrases like “professional voiceover,” “Speechify Studio,” and “studio-quality audio.” The delivery should feel natural, like a helpful guide rather than a salesperson.',
    default: false,
    defaultText:
      "Welcome to our training module! [enthusiastic] In this session, you'll learn how to create professional voiceover in minutes. With Speechify Studio, you can simply type your script, choose from dozens of natural, expressive voices, and generate studio-quality audio instantly. No microphones, no editing — just polished narration ready to use. [excited] Try it today and sound like a pro!",
    defaultVoice: 'Chloe',
  },
  {
    style: 'Sports Commentator',
    prompt:
      'Energetic, fast-paced, crisp American accent; rising intonation, dramatic pauses, thrilling delivery.',
    default: false,
    defaultText:
      '[very quickly] And we’re off here at the Chase Center — the energy is electric for this Western Conference clash! The Warriors waste no time — [excited] Curry with the handle, crosses midcourt, a quick screen—pulls up from deep! [shouting] OH, HE GOT IT! From way downtown! The crowd’s on its feet, and Golden State are heating up early! This is vintage Warriors basketball!',
    defaultVoice: 'Jason',
  },
  {
    style: 'Professional Intro',
    prompt:
      'A warm, confident, and approachable baritone with a touch of enthusiasm.  A tone similar to a friendly, tech-savvy professional—clear enunciation, a slight smile in the delivery. A subtle hint of charisma, like Chris Hemsworth narrating a commercial',
    default: false,
    defaultText:
      'Welcome to Aether Innovations! [enthusiastic] We’re a passionate team creating cutting-edge software solutions. [energetic] From mobile apps to AI analytics, we turn your ideas into reality. [confident] Need a tech partner? [friendly] Reach out and let’s build something amazing together!',
    defaultVoice: 'Walter',
  },
];
